"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Port = void 0;
class Port {
    name;
    contract;
    /**
     * @param name     the port's identity — what the diagram pairs and the allowlists name
     * @param contract what crosses it, or `null` for a port the kernel does not yet verify. Every
     *                 backend port acquires one under the 2026-09-11 programme; `null` remains the
     *                 frontend's state, where the seam is verified by `@ml3d/contract` instead.
     */
    constructor(name, contract = null) {
        this.name = name;
        this.contract = contract;
    }
}
exports.Port = Port;
//# sourceMappingURL=Port.js.map